"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTooltipContent = exports.BaseTooltip = void 0;
const Tooltip = __importStar(require("@radix-ui/react-tooltip"));
const tailwind_merge_1 = require("tailwind-merge");
const BaseTooltip = (props) => {
    const { children, tooltip, delay = 100 } = props;
    return (<Tooltip.Provider delayDuration={delay}>
			<Tooltip.Root>
				<Tooltip.Trigger>
					{children}
				</Tooltip.Trigger>
				<Tooltip.Portal>
					<Tooltip.Content collisionPadding={5} className="-translate-y-1 z-[100]">
						{tooltip}
					</Tooltip.Content>
				</Tooltip.Portal>
			</Tooltip.Root>
		</Tooltip.Provider>);
};
exports.BaseTooltip = BaseTooltip;
const BaseTooltipContent = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return <p className={(0, tailwind_merge_1.twMerge)('text-xs p-2 text-center rounded bg-secondary animate-slide-up motion-reduce:animate-none', className)} {...props}>{children}</p>;
};
exports.BaseTooltipContent = BaseTooltipContent;
